<template>
  <Form
    :form-id="dealFormId"
    :initial-values="offerSheet || {}"
    :class="{ dirty }"
    class="section"
  >
    <div class="row-label pb-1">
      Deal
    </div>
    <VPDealPicker
      percent-input-id="dealGborPercentage"
      amount-input-id="dealArtistGuarantee"
      type-of-deal="ticket"
      @change="saveOfferSheet"
    />
  </Form>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Form, useFormsStore } from 'vuniform';
import VPDealPicker from '@/components/form/VPDealPicker.vue';
import { type SaveOfferSheetParams, useOfferSheetStore } from '@/stores/offer-sheet';
import { take } from '@/helpers/takePayload';

const formsStore = useFormsStore();
const offerSheetStore = useOfferSheetStore();
const offerSheet = computed(() => offerSheetStore.offerSheet);
const loading = computed(() => offerSheetStore.offerSheetLoading);

const dealFormId = 'offer-sheets-deal';

const dirty = computed(() => formsStore.isFormDirty(dealFormId));

const saveOfferSheet = async () => {
  if (loading.value || !formsStore.isFormDirty(dealFormId)) {
    return;
  }
  const offerSheetParams = formsStore.formGetValues(dealFormId);
  const payload: SaveOfferSheetParams = Object.assign({}, offerSheet.value, offerSheetParams);
  payload.offerSheetId = offerSheet.value.id;
  await offerSheetStore.updateOfferSheet(
    take(payload, 'id', 'dealType', 'dealArtistGuarantee', 'dealGborPercentage', 'supportGuarantee'),
    ['dealArtistGuarantee', 'dealGborPercentage', 'supportGuarantee'],
  );

  formsStore.SET_INITIAL_VALUES({
    values: { ...offerSheet.value },
    formId: dealFormId,
    clearDirty: true,
  });
};
</script>
